// use client: `year` tab state with onClick handlers
'use client'

import './ServiceUpdate.css'

import type { ServiceUpdate } from '@/types'

import { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import moment from 'moment'

import Link from '@/components/Link'
import { parseCmsHtml } from '@/utils'

// Display date format; parsing the sort key with this explicit format avoids
// moment's locale-dependent non-ISO fallback (and the build-time deprecation warning).
const DISPLAY_DATE_FORMAT = 'DD MMM YYYY'

const ServiceUpdates = ({ initialData }: { initialData?: ServiceUpdate[] }) => {
  // Content comes from the build-time snapshot only. A Strapi publish rebuilds
  // and redeploys the site, so there is nothing to revalidate on mount.
  // See tests/no-client-cms-fetch.spec.ts.
  const serviceUpdatesList: ServiceUpdate[] = initialData ?? []
  const [year, setYear] = useState<string>(initialData?.[0]?.yearTag ?? '')

  const yearTags = [...new Set(serviceUpdatesList.map(update => update.yearTag))]

  return (
    <div className="service-updates container my-5">
      <div className="heading">Service Updates</div>
      <div className="year-selector">
        {yearTags.map(y => (
          <button
            key={y}
            className={`year-btn ${year === y ? `active` : ``}`}
            onClick={() => setYear(y)}
          >
            {y}
          </button>
        ))}
      </div>
      <Row className="update-list">
        {serviceUpdatesList
          .sort(
            (a, b) =>
              moment(b.date, DISPLAY_DATE_FORMAT).valueOf() -
              moment(a.date, DISPLAY_DATE_FORMAT).valueOf()
          )
          .filter(update => update.yearTag === year)
          .map(update => (
            <Col md={4} key={update.slug}>
              <div className="update-card">
                <div className="title">{update.title}</div>
                <div className="subtitle">{parseCmsHtml(update.content)}</div>
                <div className="cta-date">
                  <Link href={`/service-update-detail/${update.slug}`}>Read more</Link>
                  <div className="date">{update.date}</div>
                </div>
              </div>
            </Col>
          ))}
      </Row>
    </div>
  )
}

export default ServiceUpdates
